<template>
  <div class="msg msg-ok" v-if="met">
    <Icon icon="icon-good.svg"></Icon> {{ msg }}
  </div>
  <div class="msg msg-invalid" v-else>
    <Icon icon="icon-error.svg"></Icon> {{ msg }}
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import Icon from "@/modules/ui/Icon.vue";

@Options({
  props: {
    met: Boolean,
    msg: String,
  },
  components: {
    Icon,
  },
})
export default class PasswordRuleMet extends Vue {}
</script>

<style lang="scss" scoped>
.msg {
  line-height: 15px;
  display: flex;
  font-size: 12px;
  margin-bottom: 4px;

  img {
    margin-right: 8px;
  }
}

.msg-invalid {
  color: var(--error-color);
}

.msg-ok {
  color: var(--success-color);
}
</style>
